import { Box } from '@wix/design-system';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React from 'react';
import { PERCEPTION_VOUCHER_BANNER } from '../../pricingPerception';
import { FAQs } from '../../Components/FAQs';
import { SiteGateHeader } from '../../Components/Headers';
import { MoreTools } from '../../Components/MoreTools';
import { PreSuggestions } from '../../Components/PreSuggestions';
import { TldPromotionsWithPrice } from '../../Components/TldPromotionsWithPrice';
import { VoucherBanner } from '../../Components/VoucherBanner';
import { useDomainSearchGateBi } from '../../hooks/useDomainSearchGateBi';
import { useQuerySubmit } from '../../hooks/useQuerySubmit';
import { prefetchRecommendations } from '../../hooks/useRecommendations';
import { useViewTransition } from '../../hooks/useViewTransition';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import transition from '../viewTransitions.css';
import s from './searchGateHome.scss';
import { SocialProofCard } from '../../Components/SocialProofCard';
import { ViewMode } from '../../types';
import { useDeclaredExperiments } from '../../hooks/declaredExperiments';
import { useGatePageBackground } from '../../hooks/useGatePageBackground';
export const SearchGateHomeContent = function (_temp) {
  let {
    hideBackButton,
    viewMode = ViewMode.GATE,
    perception = false,
    titleKey
  } = _temp === void 0 ? {} : _temp;
  const pageBackground = useGatePageBackground();
  DomainSearchGateModule.SDK.hooks.useDomainsSearchGateBM();
  const {
    navigateBack,
    navigateTo
  } = useViewTransition();
  const experimentIds = useDeclaredExperiments();
  const {
    getUrlState
  } = DomainSearchSuiteModule.SDK.hooks.useUrlRecovery();
  useDomainSearchGateBi({
    viewMode,
    pageType: 'landing'
  });
  useQuerySubmit({});
  return /*#__PURE__*/React.createElement(Box, {
    padding: "16px 48px",
    direction: "vertical",
    gap: "SP4",
    align: "center",
    width: "100%",
    overflow: "auto",
    backgroundColor: pageBackground,
    scrollBehavior: "smooth",
    height: "100%",
    display: "grid",
    gridTemplateRows: "max-content max-content 1fr",
    gridTemplateAreas: " \"banner\" \"header\" \"content\" "
  }, /*#__PURE__*/React.createElement("section", {
    className: s.voucherBannerContainer
  }, /*#__PURE__*/React.createElement(VoucherBanner, {
    optimizedVoucherCopy: true,
    configOverrides: perception ? PERCEPTION_VOUCHER_BANNER : undefined
  })), /*#__PURE__*/React.createElement("header", {
    className: s.header
  }, /*#__PURE__*/React.createElement(Box, {
    align: "center",
    borderRadius: "12px",
    width: "100%",
    direction: "vertical",
    gap: "SP4",
    boxSizing: "border-box",
    padding: "24px 32px 48px",
    backgroundColor: "#E2D8FF",
    overflow: "hidden",
    zIndex: 1
  }, /*#__PURE__*/React.createElement(SiteGateHeader, {
    titleKey: titleKey,
    onBackClick: hideBackButton ? undefined : () => {
      DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
        ctaClick: 'back_button'
      });
      navigateBack();
    },
    className: transition.header
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%'
    },
    className: transition.searchBar
  }, /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.DomainSearchBar, {
    autoFocus: false,
    onFiltersChange: (key, value) => {
      if (key === 'tlds') {
        DomainSearchSuiteModule.internals.bi.onSelectTld == null || DomainSearchSuiteModule.internals.bi.onSelectTld({
          tld: JSON.stringify(value)
        });
      } else {
        DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
          ctaClick: key,
          value: JSON.stringify(value)
        });
      }
    },
    onSubmit: filters => {
      prefetchRecommendations({
        experimentIds
      });
      setTimeout(() => {
        const searchParams = getUrlState(filters);
        navigateTo(`/results?${searchParams}`);
      }, 500);
    }
  })))), /*#__PURE__*/React.createElement("main", {
    className: transition.content,
    tabIndex: -1
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP4",
    display: "grid",
    className: s.content,
    gridTemplateRows: "repeat(max-content, auto)"
  }, /*#__PURE__*/React.createElement(PreSuggestions, {
    perception: perception
  }), /*#__PURE__*/React.createElement(SocialProofCard, null), /*#__PURE__*/React.createElement(TldPromotionsWithPrice, null), /*#__PURE__*/React.createElement(MoreTools, null), /*#__PURE__*/React.createElement(FAQs, {
    onToggle: index => {
      DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
        ctaClick: 'asked_questions',
        value: JSON.stringify(index)
      });
    }
  }))));
};
//# sourceMappingURL=SearchGateHomeContent.js.map